/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    CoverAndBenefits: {
        id: 'cep.components.sgRenewalSptUpgradeTable.CoverAndBenefits',
        defaultMessage: 'Cover and benefits'
    },
    SagaStandard: {
        id: 'cep.components.sgRenewalSptUpgradeTable.SagaStandard',
        defaultMessage: 'Saga Standard'
    },
    ExistingCover: {
        id: 'cep.components.sgRenewalSptUpgradeTable.ExistingCover',
        defaultMessage: '(your existing cover)'
    },
    SagaPlus: {
        id: 'cep.components.sgRenewalSptUpgradeTable.SagaPlus',
        defaultMessage: 'Saga Plus'
    },
    CancellationCover: {
        id: 'cep.components.sgRenewalSptUpgradeTable.CancellationCover',
        defaultMessage: 'Cancellation cover'
    },
    CancellationCoverText: {
        id: 'cep.components.sgRenewalSptUpgradeTable.CancellationCoverText',
        defaultMessage: ' - we will pay up to the amount shown if you are forced to cancel your trip.'
    },
    CancellationCoverStandard: {
        id: 'cep.components.sgRenewalSptUpgradeTable.CancellationCoverStandard',
        defaultMessage: '£10,000'
    },
    CancellationCoverPlus: {
        id: 'cep.components.sgRenewalSptUpgradeTable.CancellationCoverPlus',
        defaultMessage: '£20,000'
    },
    MedicalExpenses: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MedicalExpenses',
        defaultMessage: 'Medical and associated expenses'
    },
    MedicalExpensesText: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MedicalExpensesText',
        defaultMessage: ' - we can help if you need emergency medical treatment, repatriation to the UK and more while you are abroad.'
    },
    MedicalExpensesStandard: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MedicalExpensesStandard',
        defaultMessage: '£10,000,000 abroad £2,000,000 UK'
    },
    MedicalExpensesPlus: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MedicalExpensesPlus',
        defaultMessage: '£20,000,000 abroad £2,000,000 UK'
    },
    LostBaggage: {
        id: 'cep.components.sgRenewalSptUpgradeTable.LostBaggage',
        defaultMessage: 'Lost, stolen or damaged baggage'
    },
    LostBaggageText: {
        id: 'cep.components.sgRenewalSptUpgradeTable.LostBaggageText',
        defaultMessage: ' - items that are usually carried during a trip are covered if they get lost, stolen or damaged.'
    },
    LostBaggageStandard1: {
        id: 'cep.components.sgRenewalSptUpgradeTable.LostBaggageStandard1',
        defaultMessage: '£5,000'
    },
    LostBaggageStandard2: {
        id: 'cep.components.sgRenewalSptUpgradeTable.LostBaggageStandard2',
        defaultMessage: '(£750 single article limit)'
    },
    LostBaggagePlus1: {
        id: 'cep.components.sgRenewalSptUpgradeTable.LostBaggagePlus1',
        defaultMessage: '£10,000'
    },
    LostBaggagePlus2: {
        id: 'cep.components.sgRenewalSptUpgradeTable.LostBaggagePlus2',
        defaultMessage: '(£1,250 single article limit)'
    },
    DelayedDeparture: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedDeparture',
        defaultMessage: 'Delayed departure'
    },
    DelayedDepartureText: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedDepartureText',
        defaultMessage: ' - if the ship, train, or aircraft is delayed in leaving or returning home we will pay towards meals and refreshments during the delay.'
    },
    DelayedDepartureStandard1: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedDepartureStandard1',
        defaultMessage: '£35 for each 12 hour period'
    },
    DelayedDepartureStandard2: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedDepartureStandard2',
        defaultMessage: '(£215 maximum)'
    },
    DelayedDeparturePlus1: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedDeparturePlus1',
        defaultMessage: '£50 for each 12 hour period'
    },
    DelayedDeparturePlus2: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedDeparturePlus2',
        defaultMessage: '(£300 maximum)'
    },
    DelayedAssistance: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedAssistance',
        defaultMessage: 'Delayed flight assistance'
    },
    DelayedAssistanceText: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedAssistanceText',
        defaultMessage: ' - if your flight is delayed you will be given complimentary access to an airport lounge.'
    },
    DelayedAssistanceStandard: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedAssistanceStandard',
        defaultMessage: 'Yes - 2 hour delay'
    },
    DelayedAssistancePlus: {
        id: 'cep.components.sgRenewalSptUpgradeTable.DelayedAssistancePlus',
        defaultMessage: 'Yes - 1 hour delay'
    },
    EnforcedStay: {
        id: 'cep.components.sgRenewalSptUpgradeTable.EnforcedStay',
        defaultMessage: 'Enforced stay'
    },
    EnforcedStayText: {
        id: 'cep.components.sgRenewalSptUpgradeTable.EnforcedStayText',
        defaultMessage: ' - provides cover, up to the amount shown, if you are unable to reach your destination or return home and have to make alternative arrangements.'
    },
    EnforcedStayStandard1: {
        id: 'cep.components.sgRenewalSptUpgradeTable.EnforcedStayStandard1',
        defaultMessage: '£100 for each 24 hour period'
    },
    EnforcedStayStandard2: {
        id: 'cep.components.sgRenewalSptUpgradeTable.EnforcedStayStandard2',
        defaultMessage: '(£1,500 maximum)'
    },
    EnforcedStayPlus1: {
        id: 'cep.components.sgRenewalSptUpgradeTable.EnforcedStayPlus1',
        defaultMessage: '£100 for each 24 hour period'
    },
    EnforcedStayPlus2: {
        id: 'cep.components.sgRenewalSptUpgradeTable.EnforcedStayPlus2',
        defaultMessage: '(£2,000 maximum)'
    },
    MissedDeparture: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MissedDeparture',
        defaultMessage: 'Missed departure'
    },
    MissedDepartureText: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MissedDepartureText',
        defaultMessage: ' - we can cover extra travel and accommodation costs if you arrive late due to reasons set out in the policy booklet.'
    },
    MissedDepartureStandard: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MissedDepartureStandard',
        defaultMessage: '£750'
    },
    MissedDeparturePlus: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MissedDeparturePlus',
        defaultMessage: '£1,500'
    },
    MissedPort: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MissedPort',
        defaultMessage: 'Cruise - Missed port'
    },
    MissedPortText: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MissedPortText',
        defaultMessage: ' - compensation if you are unable to disembark at any ports on your itinerary due to adverse weather or timetable restrictions.'
    },
    MissedPortPlus1: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MissedPortPlus1',
        defaultMessage: '£100 per port'
    },
    MissedPortPlus2: {
        id: 'cep.components.sgRenewalSptUpgradeTable.MissedPortPlus2',
        defaultMessage: '(£300 maximum)'
    },
    CruiseRejoin: {
        id: 'cep.components.sgRenewalSptUpgradeTable.CruiseRejoin',
        defaultMessage: 'Cruise - Interruption'
    },
    CruiseRejoinText: {
        id: 'cep.components.sgRenewalSptUpgradeTable.CruiseRejoinText',
        defaultMessage: ' - cover for additional expenses to re-join your cruise, up to the amount shown, if you temporarily disembark for hospital treatment on dry land.'
    },
    CruiseRejoinPlus: {
        id: 'cep.components.sgRenewalSptUpgradeTable.CruiseRejoinPlus',
        defaultMessage: '£1,000'
    },
    No: {
        id: 'cep.components.sgRenewalSptUpgradeTable.No',
        defaultMessage: 'No'
    }
});
